import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog")
      .then((r) => setPosts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const [featured, ...rest] = posts;

  return (
    <Layout>
      <section className="py-28 border-b border-white/10" data-testid="blog-hero">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="eyebrow">Blog & Resources</span>
          <h1 className="heading-massive mt-4">Field notes on the <span className="text-tratou-green">post-diesel grid.</span></h1>
        </div>
      </section>

      {loading && (
        <div className="py-24 text-center text-tratou-dim font-mono text-sm" data-testid="blog-loading">Loading...</div>
      )}

      {featured && (
        <section className="py-16" data-testid="blog-featured">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
            <Link to={`/blog/${featured.slug}`} className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10 group">
              <div className="aspect-[16/10] md:aspect-auto overflow-hidden">
                <img src={featured.cover_image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
              </div>
              <div className="bg-tratou-deep p-8 md:p-12 flex flex-col justify-center">
                <p className="eyebrow">Featured · {featured.category}</p>
                <h2 className="mt-4 font-display text-3xl md:text-4xl font-bold leading-tight group-hover:text-tratou-green transition">{featured.title}</h2>
                <p className="mt-4 text-tratou-dim text-lg">{featured.excerpt}</p>
                <span className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] text-tratou-green">
                  Read article <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          </div>
        </section>
      )}

      {rest.length > 0 && (
        <section className="py-16" data-testid="blog-grid">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {rest.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="bg-tratou-deep group panel-hover" data-testid={`blog-card-${p.slug}`}>
                <div className="aspect-video overflow-hidden">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
                </div>
                <div className="p-6">
                  <p className="eyebrow">{p.category} · {p.read_time}</p>
                  <h3 className="mt-3 font-display font-bold text-xl group-hover:text-tratou-green transition">{p.title}</h3>
                  <p className="mt-3 text-tratou-dim text-sm">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </Layout>
  );
}
